import React from 'react';
import { ArchiveRestore, Building2, CalendarClock, FileText, FolderClosed } from 'lucide-react';
import { ApplicationSummary } from '../../types';
import { COLUMN_META, EMPLOYMENT_LABELS } from './kanbanConstants';
import { formatDate } from '../../utils/formatDate';

interface Props {
  application: ApplicationSummary;
  onClick: () => void;
  onRestore: () => void;
}

const ArchivedCard: React.FC<Props> = ({ application, onClick, onRestore }) => {
  const meta = COLUMN_META[application.status];

  return (
    <div
      onClick={onClick}
      className="bg-white border border-zinc-200 rounded-card p-4 shadow-soft cursor-pointer select-none hover:shadow-elevated transition-all duration-300 flex items-start gap-3"
    >
      {application.organizationLogo ? (
        <img
          src={application.organizationLogo}
          alt=""
          className="w-10 h-10 rounded-btn object-cover border border-zinc-100 shrink-0 bg-white"
        />
      ) : (
        <div className="w-10 h-10 rounded-btn bg-brand-50 flex items-center justify-center shrink-0">
          <Building2 className="w-5 h-5 text-brand-500" />
        </div>
      )}

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <p className="text-sm font-semibold text-foreground truncate">{application.jobTitle}</p>
          <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded shrink-0 ${meta.badge}`}>
            {meta.label}
          </span>
        </div>
        <p className="text-xs text-zinc-500 mt-0.5 truncate">{application.organizationName}</p>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1.5 text-[11px] text-zinc-400">
          {application.resumeLabel && (
            <span className="inline-flex items-center gap-1">
              <FileText className="w-3 h-3" /> {application.resumeLabel}
            </span>
          )}
          {application.employmentType && (
            <span className="inline-flex items-center gap-1">
              <FolderClosed className="w-3 h-3" /> {EMPLOYMENT_LABELS[application.employmentType]}
            </span>
          )}
          {application.archivedAt && (
            <span className="inline-flex items-center gap-1">
              <CalendarClock className="w-3 h-3" /> Archived {formatDate(application.archivedAt)}
            </span>
          )}
          {application.appliedAt && <span>Applied {formatDate(application.appliedAt)}</span>}
        </div>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onRestore();
        }}
        className="h-8 px-3 mt-2 sm:mt-0 inline-flex items-center gap-1.5 text-xs font-medium text-emerald-700 bg-emerald-50 hover:bg-emerald-100 rounded-btn transition-colors shrink-0"
        title="Restore to the board"
      >
        <ArchiveRestore className="w-3.5 h-3.5" /> Restore
      </button>
    </div>
  );
};

export default ArchivedCard;